import { Box, Button, Card, Typography } from "@mui/material";
import HeaderComponent from "../subComponent/HeaderComponent";
// import billPay from "../data/images/billpay.png";
import invpay from "../data/images/INV-Payments.png";
import { useState } from "react";

const ExpandableText = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleText = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <Typography sx={{ fontSize: "14px", textAlign: "justify", mb: 1 }}>
                {isExpanded ? text : `${text.substring(0, 100)}...`}
                <Button onClick={toggleText} style={{ fontSize: "10px" }}>{isExpanded ? "Show Less" : "Show More"}</Button>
            </Typography>
        </>
    );
};

const Home = () => {

    const cardTypocolored = {
        fontSize: "16px",
        fontWeight: "bold",
        textAlign: "center",
        background: "linear-gradient(250deg, rgba(247,146,51,1) 0%, rgba(3,62,110,1) 100%)",
        padding: "5px",
        borderRadius: "10px",
        marginBottom: "10px",
    }

    const cardMain = {
        width: "300px", height: "auto", backgroundColor: "#191a1c", color: "white", padding: "20px", marginTop: "20px",
    }

    const cardHeading = {
        fontSize: "16px", fontWeight: "bold", textAlign: "center", marginBottom: 1,
    }

    const domainDescription = "We are here to help you with your DOMAIN purchasing and renewal of it."
    const serverDescription = "We are here to help you with your Server/Hosting purchasing and renewal of it."
    const payrollDescription = "Payroll Management System is a comprehensive software solution designed to streamline and automate payroll processes, ensuring accurate and timely payment of salaries and wages to employees. It offers features such as employee management, tax calculations, direct deposit, and reporting, providing a seamless experience for both employers and employees.";

    const employeeDescription = "Employee Management System is a comprehensive software solution designed to streamline and automate employee management processes, ensuring accurate and timely management of employee data, including personal information, job details, and performance records. It offers features such as employee management, tax calculations, direct deposit, and reporting, providing a seamless experience for both employers and employees.";

    return (
        <Box>
            <HeaderComponent />
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box component="img"
                    sx={{
                        width: { xs: "90%", md: "60%" },
                        height: { xs: "50vh", md: "calc(100vh - 60px)" },
                        // backgroundColor: "#191a1c",
                    }}
                    alt="Bill Pay"
                    src={invpay} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Typography sx={{ color: "white", background: "linear-gradient(250deg, rgba(247,146,51,1) 0%, rgba(3,62,110,1) 100%)", padding: "15px", borderRadius: "15px", fontSize: { xs: "18px", md: "30px" }, fontWeight: "bold" }}>Pricing of Our Products & Services</Typography>
            </Box>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: { md: "start", xs: "center" }, justifyContent: "space-evenly" }}>
                <Card style={cardMain}>
                    <Typography style={cardHeading}>Domain Service</Typography>
                    <ExpandableText text={domainDescription} />
                    <Typography style={cardTypocolored}>Starter : ₹1000/Year</Typography>
                    <Typography style={cardTypocolored}>Renewal : ₹1500/Year</Typography>
                    <Typography style={cardTypocolored}>Expert : ₹2800/2 Years</Typography>
                    <Typography style={cardTypocolored}>Premium : ₹4000/3 Years</Typography>
                </Card>
                <Card style={cardMain}>
                    <Typography style={cardHeading}>Server/Hosting Service</Typography>
                    <ExpandableText text={serverDescription} />
                    <Typography style={cardTypocolored}>Premium : ₹950/Month</Typography>
                    <Typography style={cardTypocolored}>Business  : ₹1100/Month</Typography>
                    <Typography style={cardTypocolored}>Cloud Professional : ₹4500/Month</Typography>
                    <Typography style={cardTypocolored}>Cloud Enterprise : ₹8000/Month</Typography>
                </Card>
                <Card style={cardMain}>
                    <Typography style={cardHeading}>Payroll Management System</Typography>
                    <ExpandableText text={payrollDescription} />
                    <Typography style={cardTypocolored}>Premium : ₹1000/Month</Typography>
                    <Typography style={cardTypocolored}>Business : ₹10000/Year</Typography>
                    <Typography style={cardTypocolored}>Cloud : ₹25000/3 Years</Typography>
                </Card>
                <Card style={cardMain}>
                    <Typography style={cardHeading}>Employee Management System</Typography>
                    <ExpandableText text={employeeDescription} />
                    <Typography style={cardTypocolored}>Premium : ₹1000/Month</Typography>
                    <Typography style={cardTypocolored}>Business : ₹10000/Year</Typography>
                    <Typography style={cardTypocolored}>Cloud : ₹25000/3 Years</Typography>
                </Card>
            </Box>
        </Box>
    )
}
export default Home;
